import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=2ed9433e&scoped=true"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"
import style0 from "./LoginModal.vue?vue&type=style&index=0&id=2ed9433e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed9433e",
  null
  
)

export default component.exports